import { render } from "./FormCallBack.vue?vue&type=template&id=950217dc&scoped=true"
import script from "./FormCallBack.vue?vue&type=script&lang=js"
export * from "./FormCallBack.vue?vue&type=script&lang=js"

import "./FormCallBack.vue?vue&type=style&index=0&id=950217dc&scoped=true&lang=css"

import exportComponent from "/Users/nikita/Documents/works/novofamil/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-950217dc"]])

export default __exports__